module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-76x76.c8fdc39f9bc2cde3d4f9405073bd4e8a.png";